export default __webpack_public_path__ + "static/media/whatsapp.0fde1f87.svg";